export default "__VITE_ASSET__D_ecQfWC__"